import { RestApiError } from "@/api/restMiddleware";

export const applyRestApiErrorContext = (event, hint) => {
  const error = hint?.originalException;
  if (!(error instanceof RestApiError)) return event;

  const status = String(error.status ?? "network");

  event.fingerprint = ["rest-api", error.method, error.route, status];
  event.tags = {
    ...event.tags,
    rest_api_route: error.route,
    rest_api_status: status,
  };
  event.contexts = {
    ...event.contexts,
    rest_api: {
      method: error.method,
      url: error.url,
      route: error.route,
      status: error.status,
      body: error.body,
    },
  };
  return event;
};
